import { NavGroupType } from './types';
import { ShoppingOutlined, FormOutlined } from '@ant-design/icons';

const thriftshop: NavGroupType = {
    id: 'thriftshop-group',
    type: 'group',
    title: 'menu.thriftshop.title',
    children: {} as { [key: string]: any },
    disabled: {
        qlive_thriftshop_listing_list: {
            id: 'thriftshop-listing',
            icon: ShoppingOutlined,
            type: 'item',
            title: 'menu.thriftshop.listing.title',
            url: '/shop/listings',
        },
        qlive_thriftshop_template_list: {
            id: 'thriftshop-template',
            icon: FormOutlined,
            type: 'item',
            title: 'menu.thriftshop.template.title',
            url: '/shop/templates',
        },
    },
};

export default thriftshop;
